import { render, staticRenderFns } from "./BkklistHome.vue?vue&type=template&id=7db0e932&"
import script from "./BkklistHome.vue?vue&type=script&lang=js&"
export * from "./BkklistHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports